import indicadorReportSummary from "entity/Indicador/reports/IndicadorReportSummary";
import TableReportHelper from "report/helper";

export default async function asReportSummary(indicador, visita, tipoName) {
    const h = new TableReportHelper(visita.data);
    const IndicadorClass = indicador.constructor;

    const params = visita.cliente.getParams(IndicadorClass, tipoName, indicador.type)

    if (!params) {
        return null;
    }

    const chartSegments = [0, parseInt(params.meta), parseInt(params.meta) + 5, 100];

    async function getChart(conformidade) {
        return h.gaugeChart(
            {
                width: 210,
                height: 130,
                segmentsColors: ["#6bd72d", "#ecdb23", "#fe4719"],
                // maxSegmentLabels: 5,
                customSegmentStops: chartSegments,
                segments: 3,
                series: [{ name: "", values: conformidade }],
            },
            { alignment: "center", colSpan: 3 }
        );
    }

    return indicadorReportSummary(indicador, visita, tipoName, params, getChart);
}
